module.exports = __webpack_public_path__ + "a09ad22ba8d8827376d9620ca6ad438f.svg";